var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-visuals"},[_c('my-header',{attrs:{"page_name":_vm.$t('navigation.headerTitles.visuals'),"show_usermenu":""}}),_c('tree',{staticStyle:{"max-height":"90vh"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }